import React, { Component } from 'react';
import { connect } from 'react-redux';
import OwlCarousel from 'react-owl-carousel2';
import axios from 'axios';
import Loader from 'react-loader-spinner';
import Layout from '../layout/Layout';
import {ToastsContainer, ToastsStore,ToastsContainerPosition} from 'react-toasts';
var fs = require('browserify-fs');
const API_URL = process.env.REACT_APP_API_URL;
const IMAGE_URL = process.env.REACT_APP_SITE_IMAGE_URL;

class Thankyou extends Component {
	
	constructor(props) {
        super(props);
 
        this.state = {
          
            slider: [],
			loaded: false,
			home:[],
			Ourreach:[],
			Volunteeringworks:[],
			Workingtogether:[],
			Aboutourfoundation:[],
			OurImpact:[], 
			fields: {},
			errors: {},
			languagedata:[],
			defaultlang:6,
			
			
        };
		
		
	    
    }
	
	
	
	
	

	
	componentWillMount() {
  
    
    const deflang= localStorage.getItem('DefaultLanguage');
        if(deflang == null){
           localStorage.setItem('DefaultLanguage',6);
        }

    const DefaultLang = localStorage.getItem('DefaultLanguage');
    this.setState({defaultlang: DefaultLang});


	


      this.getlanguage(DefaultLang);
    
  }


getlanguage(defaultlang){
    
   
    axios.post(`${API_URL}/langfile`, { LangId:defaultlang})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const language = res.data.ResponseData;
            let data = res.data.ResponseData[0];
           
             const mythis=this;
             this.setState({ language }); 

              this.setState({languagedata: data});
             
           
                     
            
          }
          })
        
        
        
}	

	
	
  render() {

	  
    return (
      	<div className="App">
      		 <Layout languagedata={this.state.languagedata}>
	
      			<section className="banner inner_banner">
				  <div className="bd-example">
				    <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
				      <div className="carousel-inner">
				        <div className="carousel-item active">
				          <img src={ IMAGE_URL+'/images/donate-banner.jpg' } className="d-block w-100" alt="..." />
				          
				          <div className="carousel-caption d-none d-md-block"><h1>Thank you</h1></div>
				        </div>
				      </div>
				    </div>
				  </div>
				</section>

				<section className="contact_us Donate_form">
				
				<h2 align="center">Thank you for donate us. your donate amount important to us.</h2>			

				</section>


			</Layout>
	  	</div>
    );
  }
}

export default Thankyou;



// WEBPACK FOOTER //
// ./src/component/Thankyou.js